import { idbGet, idbPut } from './idb.js';

export type OfflineManifest = {
  bibleId: string;
  completedBooks: string[];
  downloadedAt: Record<string, number>;
  version: 1;
};

export async function getOfflineManifest(
  bibleId: string,
): Promise<OfflineManifest | null> {
  const result = await idbGet<OfflineManifest>('meta', `offline-manifest:${bibleId}`);
  return result ?? null;
}

export async function commitBookToManifest(
  bibleId: string,
  bookId: string,
): Promise<void> {
  const existing = await getOfflineManifest(bibleId);
  const manifest: OfflineManifest = existing ?? {
    bibleId,
    completedBooks: [],
    downloadedAt: {},
    version: 1,
  };
  const upper = bookId.toUpperCase();
  if (!manifest.completedBooks.includes(upper)) {
    manifest.completedBooks.push(upper);
  }
  manifest.downloadedAt[upper] = Date.now();
  await idbPut('meta', `offline-manifest:${bibleId}`, manifest);
}

export function offlineKey(
  bibleId: string,
  book: string,
  chapter: number,
  type: 'audio' | 'text' | 'timing',
): string {
  return `offline:${bibleId}:${book.toUpperCase()}.${chapter}:${type}`;
}
